<template>
    <div class="category-main" v-if="isLoaded && isHaveCategory">
        <div
            class="category-item"
            v-for="(category, k) in categories"
            :key="k"
            @click="clickCategory(category, k)"
        >
            <a
                :class="{ 'selected-category': current_click == k }"
                class="category-text"
            >
                {{ category.name }}
            </a>
        </div>
    </div>
</template>
<script>
//base
import Account from "@/helper/AccountHelper.js";
//service
import BzbsCategory from "@/core/Campaign/service/BzbsCategory.js";

export default {
    name: "CategorySlider",
    components: {},
    props: {
        locale: Number,
        categoryConfig: Object,
        busEvent: Object,
    },
    data: function () {
        return {
            currentTab: "",
            isTabActive: true,
            categories: [],
            isHaveCategory: false,
            isLoaded: false,
            current_click: 0,
        };
    },
    mounted: function () {
        this.busEvent.$on("switchLang", this.switchLang);
    },
    created: function () {
        this.initialCategory();
    },
    methods: {
        clickCategory: function (category, k) {
            k == undefined
                ? (this.current_click = 0)
                : (this.current_click = k);
            this.$emit("changeCategory", category);
        },
        initialCategory: function () {
            return new Promise((resolve) => {
                var categoryParam = this.categoryConfig.getParams();

                var token = Account.getToken();
                BzbsCategory.apiGetCategory(token, categoryParam).subscribe(
                    (categories) => {
                        // console.log('categories :: ',categories, categoryParam)
                        for (var category of categories) {
                            this.categories.push(category);
                        }

                        this.isLoaded = true;
                        this.isHaveCategory =
                            this.categories.length > 0 ? true : false;

                        this.clickCategory(this.categories[0]);
                        resolve(categories);
                    },
                    (err) => {
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        console.log(err);
                    }
                );
            });
        },
        switchLang: function () {
            this.categories = [];
            this.initialCategory();
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/style/_mixin.scss";
.category-main {
    margin-left: 1.25rem;
    overflow-x: scroll;
    white-space: nowrap;
    height: 2.25rem;

    .category-item {
        margin-right: 0.75em;
        display: flex;
        align-items: center;
        justify-content: center;
        display: inline-block;
        // overflow-x: scroll;

        .category-text {
            font-size: 16px;
            color: $color-text;
            text-overflow: ellipsis;
            padding: 0 10px;
            height: 32px;
            line-height: 32px;
        }
        .selected-category {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 20px;
            width: 100%;
            color: #fff;
            background-color: #4d341c;
        }
    }
}
.category-main::-webkit-scrollbar {
    display: none;
}
</style>
